import React, { useEffect, useRef, useState } from 'react';
import logoIcon from './taron-logo.png'; // Use your actual image path or URL

const RestaurantMap = () => {
  const mapRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);

  const locations = [
    { name: "Taron Glendale", lat: 34.1469, lng: -118.2551, url: "/locations/glendale" },
    { name: "Taron North Hollywood", lat: 34.187, lng: -118.3813, url: "/locations/north-hollywood" },
    { name: "Taron Hollywood", lat: 34.1016392, lng: -118.2974279, url: "/locations/hollywood" },
  ];

  useEffect(() => {
    const handleGoogleMapsReady = () => {
      console.log('✅ google-maps-ready event received');
      setMapReady(true);
    };

    // ✅ Catch if Google Maps is already available before this component mounted
    if (window.google?.maps) {
      handleGoogleMapsReady();
    } else {
      // ✅ Otherwise, wait for the custom event
      document.addEventListener('google-maps-ready', handleGoogleMapsReady);
      return () => {
        document.removeEventListener('google-maps-ready', handleGoogleMapsReady);
      };
    }
  }, []);

  useEffect(() => {
    if (!mapReady || !mapRef.current) return;

    const map = new window.google.maps.Map(mapRef.current, {
      center: { lat: 34.15, lng: -118.25 },
      zoom: 13,
      styles: [
        { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        { featureType: 'poi', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', stylers: [{ color: '#ffffff' }] },
        { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', stylers: [{ color: '#c9c9c9' }] },
        { 
          featureType: 'road.local', 
          elementType: 'labels.text.fill', 
          stylers: [{ visibility: 'on' }, { color: '#616161' }] 
        },
        { 
          featureType: 'road.local', 
          elementType: 'labels.text.stroke', 
          stylers: [{ visibility: 'on' }, { color: '#f5f5f5' }] 
        },
      ],
    });

    const bounds = new window.google.maps.LatLngBounds();

    locations.forEach(({ name, lat, lng, url }) => {
      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map,
        label: {
          text: name,
          color: '#000',
          fontFamily: "superior-title",
          fontWeight: 'bold',
          fontSize: '14px',
        },
        icon: {
          url: logoIcon,
          scaledSize: new window.google.maps.Size(40, 40),
          labelOrigin: new window.google.maps.Point(20, -10),
        },
        title: name,
      });

      marker.addListener('click', () => {
        // window.location.href = url;
      });

      bounds.extend(marker.getPosition());
    });

    map.fitBounds(bounds);
  }, [mapReady]);

  return (
    <div style={{ width: '100%', height: '500px' }}>
      {mapReady ? (
        <div ref={mapRef} style={{ width: '100%', height: '100%', borderRadius: '16px' }} />
      ) : (
        <div style={{ width: '100%', height: '100%', background: '#eee', textAlign: 'center', paddingTop: '200px' }}>
          Loading map...
        </div>
      )}
    </div>
  );
};

export default RestaurantMap;